// extracted by mini-css-extract-plugin
export default {"label":"ThemeMode_label__32Zlv","icon":"ThemeMode_icon__7g7NU","input":"ThemeMode_input__nE14k","form-check-label":"ThemeMode_form-check-label__ffr25"};